<div class="field-label">{{ label | translate }}</div>
<div class="field-value">
  <ng-content></ng-content>
</div>
